import { motion } from "framer-motion";
import styled from "styled-components";
import Oblacic from "../../assets/images/oblacic.png";

const OblacicDecoration = styled(motion.img)`
  position: absolute;
  z-index: 2;
  pointer-events: none;
  max-width: ${(props) => props.$size || "8rem"};
  width: 100%;
  height: auto;
  top: ${(props) => props.$top || "20%"};
  left: ${(props) => props.$left || "auto"};
  right: ${(props) => props.$right || "auto"};
  transform: rotate(${(props) => props.$rotate || "0deg"});
  opacity: ${(props) => props.$opacity || "0.6"};
  filter: blur(${(props) => props.$blur || "0px"});

  @media (max-width: 768px) {
    max-width: ${(props) => props.$mobileSize || "5rem"};
  }
`;

const cloudConfigs = {
  default: [
    {
      $size: "7rem",
      $top: "15%",
      $left: "10%",
      $rotate: "30deg",
      $opacity: "0.7",
      $blur: "1px",
      $mobileSize: "4rem",
      initial: { opacity: 0, y: -30 },
      animate: { opacity: 0.7, y: 0 },
      transition: { duration: 1.5, delay: 0.3 },
    },
    {
      $size: "9rem",
      $top: "75%",
      $right: "8%",
      $rotate: "-45deg",
      $opacity: "0.6",
      $blur: "2px",
      $mobileSize: "5rem",
      initial: { opacity: 0, x: 50 },
      animate: { opacity: 0.6, x: 0 },
      transition: { duration: 1.8, delay: 0.7 },
    },
    {
      $size: "5rem",
      $top: "25%",
      $right: "15%",
      $rotate: "15deg",
      $opacity: "0.8",
      $blur: "0.5px",
      $mobileSize: "3rem",
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 0.8, scale: 1 },
      transition: { duration: 1.2, delay: 1 },
    },
    {
      $size: "6rem",
      $top: "60%",
      $left: "5%",
      $rotate: "-20deg",
      $opacity: "0.75",
      $blur: "1.5px",
      $mobileSize: "3.5rem",
      initial: { opacity: 0, y: 40 },
      animate: { opacity: 0.75, y: 0 },
      transition: { duration: 1.6, delay: 0.5 },
    },
    {
      $size: "8rem",
      $top: "5%",
      $right: "25%",
      $rotate: "60deg",
      $opacity: "0.65",
      $blur: "2.5px",
      $mobileSize: "4.5rem",
      initial: { opacity: 0, x: -40 },
      animate: { opacity: 0.65, x: 0 },
      transition: { duration: 2, delay: 1.2 },
    },
    {
      $size: "4rem",
      $top: "85%",
      $left: "25%",
      $rotate: "-10deg",
      $opacity: "0.9",
      $blur: "0px",
      $mobileSize: "2.5rem",
      initial: { opacity: 0, scale: 1.3 },
      animate: { opacity: 0.9, scale: 1 },
      transition: { duration: 1.4, delay: 0.9 },
    },
  ],

  experiences: [
    {
      $size: "8rem",
      $top: "35%",
      $left: "50%",
      $rotate: "30deg",
      $opacity: "0.7",
      $blur: "1px",
      $mobileSize: "4rem",
      initial: { opacity: 0, y: -30 },
      animate: { opacity: 0.7, y: 0 },
      transition: { duration: 1.5, delay: 0.3 },
    },
    {
      $size: "7rem",
      $top: "15%",
      $left: "10%",
      $rotate: "30deg",
      $opacity: "0.7",
      $blur: "1px",
      $mobileSize: "4rem",
      initial: { opacity: 0, y: -30 },
      animate: { opacity: 0.7, y: 0 },
      transition: { duration: 1.5, delay: 0.3 },
    },
    {
      $size: "9rem",
      $top: "75%",
      $right: "8%",
      $rotate: "-45deg",
      $opacity: "0.6",
      $blur: "2px",
      $mobileSize: "5rem",
      initial: { opacity: 0, x: 50 },
      animate: { opacity: 0.6, x: 0 },
      transition: { duration: 1.8, delay: 0.7 },
    },
    {
      $size: "5rem",
      $top: "25%",
      $right: "15%",
      $rotate: "15deg",
      $opacity: "0.8",
      $blur: "0.5px",
      $mobileSize: "3rem",
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 0.8, scale: 1 },
      transition: { duration: 1.2, delay: 1 },
    },
    {
      $size: "6rem",
      $top: "60%",
      $left: "5%",
      $rotate: "-20deg",
      $opacity: "0.75",
      $blur: "1.5px",
      $mobileSize: "3.5rem",
      initial: { opacity: 0, y: 40 },
      animate: { opacity: 0.75, y: 0 },
      transition: { duration: 1.6, delay: 0.5 },
    },
    {
      $size: "8rem",
      $top: "5%",
      $right: "25%",
      $rotate: "60deg",
      $opacity: "0.65",
      $blur: "2.5px",
      $mobileSize: "4.5rem",
      initial: { opacity: 0, x: -40 },
      animate: { opacity: 0.65, x: 0 },
      transition: { duration: 2, delay: 1.2 },
    },
    {
      $size: "4rem",
      $top: "85%",
      $left: "25%",
      $rotate: "-10deg",
      $opacity: "0.9",
      $blur: "0px",
      $mobileSize: "2.5rem",
      initial: { opacity: 0, scale: 1.3 },
      animate: { opacity: 0.9, scale: 1 },
      transition: { duration: 1.4, delay: 0.9 },
    },
  ],

  manyClouds: [
    // Red 1 - Vrh (0-20%)
    {
      $size: "7rem",
      $top: "3%",
      $left: "5%",
      $rotate: "25deg",
      $opacity: "0.6",
      $blur: "2px",
      $mobileSize: "4rem",
      initial: { opacity: 0, y: -30 },
      animate: { opacity: 0.6, y: 0 },
      transition: { duration: 1.5, delay: 0.2 },
    },
    {
      $size: "5rem",
      $top: "8%",
      $left: "25%",
      $rotate: "-15deg",
      $opacity: "0.75",
      $blur: "1px",
      $mobileSize: "3rem",
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 0.75, scale: 1 },
      transition: { duration: 1.3, delay: 0.5 },
    },
    {
      $size: "8rem",
      $top: "5%",
      $right: "25%",
      $rotate: "60deg",
      $opacity: "0.65",
      $blur: "2.5px",
      $mobileSize: "4.5rem",
      initial: { opacity: 0, x: -40 },
      animate: { opacity: 0.65, x: 0 },
      transition: { duration: 2, delay: 1.2 },
    },
    {
      $size: "3.5rem",
      $top: "10%",
      $right: "5%",
      $rotate: "-30deg",
      $opacity: "0.85",
      $blur: "0px",
      $mobileSize: "2rem",
      initial: { opacity: 0, y: -20 },
      animate: { opacity: 0.85, y: 0 },
      transition: { duration: 1.3, delay: 1.5 },
    },

    // Red 2 - Gornji (20-40%)
    {
      $size: "7rem",
      $top: "15%",
      $left: "10%",
      $rotate: "30deg",
      $opacity: "0.7",
      $blur: "1px",
      $mobileSize: "4rem",
      initial: { opacity: 0, y: -30 },
      animate: { opacity: 0.7, y: 0 },
      transition: { duration: 1.5, delay: 0.3 },
    },
    {
      $size: "5rem",
      $top: "25%",
      $right: "15%",
      $rotate: "15deg",
      $opacity: "0.8",
      $blur: "0.5px",
      $mobileSize: "3rem",
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 0.8, scale: 1 },
      transition: { duration: 1.2, delay: 1 },
    },
    {
      $size: "6rem",
      $top: "22%",
      $left: "45%",
      $rotate: "-40deg",
      $opacity: "0.55",
      $blur: "3px",
      $mobileSize: "3.5rem",
      initial: { opacity: 0, y: -25 },
      animate: { opacity: 0.55, y: 0 },
      transition: { duration: 1.8, delay: 0.9 },
    },
    {
      $size: "5.5rem",
      $top: "35%",
      $left: "20%",
      $rotate: "5deg",
      $opacity: "0.72",
      $blur: "1.2px",
      $mobileSize: "3.2rem",
      initial: { opacity: 0, y: 25 },
      animate: { opacity: 0.72, y: 0 },
      transition: { duration: 1.7, delay: 1.1 },
    },

    // Red 3 - Sredina (40-60%)
    {
      $size: "10rem",
      $top: "40%",
      $left: "2%",
      $rotate: "45deg",
      $opacity: "0.5",
      $blur: "3px",
      $mobileSize: "5.5rem",
      initial: { opacity: 0, x: -60 },
      animate: { opacity: 0.5, x: 0 },
      transition: { duration: 2.2, delay: 0.4 },
    },
    {
      $size: "4rem",
      $top: "45%",
      $left: "35%",
      $rotate: "-25deg",
      $opacity: "0.78",
      $blur: "0.8px",
      $mobileSize: "2.5rem",
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 0.78, scale: 1 },
      transition: { duration: 1.4, delay: 0.7 },
    },
    {
      $size: "11rem",
      $top: "50%",
      $right: "3%",
      $rotate: "75deg",
      $opacity: "0.45",
      $blur: "4px",
      $mobileSize: "6rem",
      initial: { opacity: 0, scale: 0.3 },
      animate: { opacity: 0.45, scale: 1 },
      transition: { duration: 2.5, delay: 0.8 },
    },
    {
      $size: "5rem",
      $top: "55%",
      $right: "35%",
      $rotate: "10deg",
      $opacity: "0.68",
      $blur: "1.5px",
      $mobileSize: "3rem",
      initial: { opacity: 0, x: 30 },
      animate: { opacity: 0.68, x: 0 },
      transition: { duration: 1.6, delay: 1.3 },
    },

    // Red 4 - Donji srednji (60-80%)
    {
      $size: "6rem",
      $top: "60%",
      $left: "5%",
      $rotate: "-20deg",
      $opacity: "0.75",
      $blur: "1.5px",
      $mobileSize: "3.5rem",
      initial: { opacity: 0, y: 40 },
      animate: { opacity: 0.75, y: 0 },
      transition: { duration: 1.6, delay: 0.5 },
    },
    {
      $size: "8rem",
      $top: "65%",
      $left: "30%",
      $rotate: "50deg",
      $opacity: "0.52",
      $blur: "3.5px",
      $mobileSize: "4.5rem",
      initial: { opacity: 0, y: 35 },
      animate: { opacity: 0.52, y: 0 },
      transition: { duration: 2.1, delay: 0.6 },
    },
    {
      $size: "4.5rem",
      $top: "70%",
      $left: "55%",
      $rotate: "25deg",
      $opacity: "0.82",
      $blur: "0.8px",
      $mobileSize: "2.8rem",
      initial: { opacity: 0, scale: 1.2 },
      animate: { opacity: 0.82, scale: 1 },
      transition: { duration: 1.5, delay: 0.6 },
    },
    {
      $size: "9rem",
      $top: "75%",
      $right: "8%",
      $rotate: "-45deg",
      $opacity: "0.6",
      $blur: "2px",
      $mobileSize: "5rem",
      initial: { opacity: 0, x: 50 },
      animate: { opacity: 0.6, x: 0 },
      transition: { duration: 1.8, delay: 0.7 },
    },
    {
      $size: "3rem",
      $top: "72%",
      $right: "30%",
      $rotate: "-65deg",
      $opacity: "0.88",
      $blur: "0px",
      $mobileSize: "2rem",
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 0.88, y: 0 },
      transition: { duration: 1.2, delay: 1.6 },
    },

    // Red 5 - Dno (80-100%)
    {
      $size: "4rem",
      $top: "85%",
      $left: "25%",
      $rotate: "-10deg",
      $opacity: "0.9",
      $blur: "0px",
      $mobileSize: "2.5rem",
      initial: { opacity: 0, scale: 1.3 },
      animate: { opacity: 0.9, scale: 1 },
      transition: { duration: 1.4, delay: 0.9 },
    },
    {
      $size: "6.5rem",
      $top: "82%",
      $left: "8%",
      $rotate: "35deg",
      $opacity: "0.58",
      $blur: "2.2px",
      $mobileSize: "3.8rem",
      initial: { opacity: 0, x: -45 },
      animate: { opacity: 0.58, x: 0 },
      transition: { duration: 1.9, delay: 1.0 },
    },
    {
      $size: "7.5rem",
      $top: "90%",
      $right: "20%",
      $rotate: "-55deg",
      $opacity: "0.55",
      $blur: "2.8px",
      $mobileSize: "4.2rem",
      initial: { opacity: 0, x: 35 },
      animate: { opacity: 0.55, x: 0 },
      transition: { duration: 1.9, delay: 1.4 },
    },
    {
      $size: "5rem",
      $top: "88%",
      $left: "50%",
      $rotate: "15deg",
      $opacity: "0.7",
      $blur: "1px",
      $mobileSize: "3rem",
      initial: { opacity: 0, y: 30 },
      animate: { opacity: 0.7, y: 0 },
      transition: { duration: 1.5, delay: 1.2 },
    },
    {
      $size: "4rem",
      $top: "95%",
      $right: "5%",
      $rotate: "-20deg",
      $opacity: "0.65",
      $blur: "1.8px",
      $mobileSize: "2.5rem",
      initial: { opacity: 0, scale: 0.6 },
      animate: { opacity: 0.65, scale: 1 },
      transition: { duration: 1.3, delay: 1.7 },
    },
  ],
};

const SmallClouds = ({ experiences, manyClouds }) => {
  // Odredi koju konfiguraciju koristiti
  const variant = manyClouds
    ? "manyClouds"
    : experiences
    ? "experiences"
    : "default";
  const clouds = cloudConfigs[variant];

  return (
    <>
      {clouds.map((cloud, index) => (
        <OblacicDecoration
          key={index}
          src={Oblacic}
          alt="Oblacic dekoracija"
          {...cloud}
        />
      ))}
    </>
  );
};

export default SmallClouds;
